import styles from './Headings.module.scss';
import Button from '../../buttons/Button';
import {NavLink} from 'react-router-dom';

function Headings(props) {
  const texts = [];
  if (props.title) {
    texts.push(<h1 key={0} className={styles.h1}>{props.title}</h1>);
  }

  if (props.text) {
    const textContent = (
      <div key={1} className={styles['text-row']}>
        <p className={styles.p}>{props.text}</p>
        {props.rightLink && (
          <NavLink to={props.rightLink.path} className={styles['right-link']}>
            {props.rightLink.label}
          </NavLink>
        )}
      </div>
    );
    texts.push(textContent);
  }

  return (
    <div className={styles.headings + (props.image ? ' ' + styles['has-image'] : '')}>
      {props.image && <div className={styles.image}><img src={props.image} alt={props.title ?? props.text}/></div>}

      {texts.map(text => text)}

      {props.ctas ? props.ctas.map((cta, index) => (
        <Button key={index} to={cta.path}>{cta.label}</Button>
      )) : null}
    </div>
  );
}

export default Headings;